import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import AsyncCreatableSelect from 'react-select/async-creatable';
import federalBasicPermitsApi from '../../../../data/federalBasicPermits/federalBasicPermits.api';

const styles = {};

// eslint-disable-next-line arrow-body-style
const getOnChangeByKey = (onChange, value) => {
  return function onChangeByKey(key) {
    return function mappedOnChange(newValue) {
      return onChange({
        ...value,
        [key]: newValue,
      });
    };
  };
};

const styleGuide = {
  option: (provided, state) => ({
    ...provided,
    padding: '16px 11px',
    backgroundColor: state.isFocused && 'rgb(255, 255, 255, 0.2)',
  }),

  menu: provided => ({
    ...provided,
    color: '#fff',
    fontFamily: 'Roboto, Arial',
    backgroundColor: '#424242',
    paddingTop: '8px',
    paddingBottom: '8px',
    fontSize: '1rem',
  }),

  singleValue: provided => ({
    ...provided,
    color: '#FFF',
  }),

  control: provided => ({
    ...provided,
    paddingTop: '10px',
    border: 'none',
    borderBottom: '1px solid',
    borderRadius: 0,
    fontFamily: 'Roboto, Arial',
    backgroundColor: '#3F5A72',
    color: '#FFF',
  }),

  input: provided => ({
    ...provided,
    color: '#FFF',
    fontFamily: 'Roboto, Arial, sans-serif',
  }),

  valueContainer: provided => ({
    ...provided,
    padding: 0
  }),

  placeholder: provided => ({
    ...provided,
    color: '#FFF',
    left: '1px',
    fontWeight: 100,
  }),

  loadingIndicator: provided => ({
    ...provided,
    color: '#FFF',
  })
};

const onInputAnOption = input => (input.length >= 2);

class UnstyledFBPNAutocomplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fbpnList: [],
    };
  }

  getOnChange = getOnChangeByKey(this.props.onChange, this.props.value);

  loadDataFromSuggestions = (inputData) => {
    if (inputData.length >= 2) {
      return federalBasicPermitsApi.loadSuggestions(inputData).then((result) => {
        const { data } = result;

        this.setState({ fbpnList: data });

        return new Promise(resolve => resolve(data.filter(
          v => v.toUpperCase().includes(inputData.toUpperCase())
        ).map(
          v => (
            {
              label: v.toUpperCase(),
              value: v.toUpperCase()
            }
          )
        )));
      });
    }

    return new Promise(resolve => resolve([]));
  };

  onInputChange = (inputValue) => {
    this.getOnChange('fbpn')(inputValue.value);
    const isValueInSuggestions = this.state.fbpnList.filter(x => x === inputValue.value).length <= 0;

    this.props.onNewItem(isValueInSuggestions && inputValue.value.length > 0);
  };

  render() {
    return (
      <AsyncCreatableSelect
        styles={ styleGuide }
        cacheOptions
        placeholder="FBPN"
        isValidNewOption={ onInputAnOption }
        noOptionsMessage={ () => '2 characters needed to search' }
        loadOptions={ this.loadDataFromSuggestions }
        formatCreateLabel={ inputValue => `Not seeing your license? Create "${inputValue}".` }
        onChange={ inputValue => this.onInputChange(inputValue) }
      />
    );
  }
}

UnstyledFBPNAutocomplete.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object,
  onNewItem: PropTypes.func.isRequired,
};

UnstyledFBPNAutocomplete.defaultProps = {
  value: undefined,
};

export default withStyles(styles)(UnstyledFBPNAutocomplete);
